import { USER_PREFERENCE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export default function postQueueColumnConfig(preference: {
    preferenceFor: string;
    preferences: string[];
}): Promise<{ success: boolean }> {
    return fetchWithRefresh(USER_PREFERENCE, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(preference),
    }).then((res) => {
        return res.json();
    });
}
